<div *ngIf="!DBservice.ismobile" class="d__flex header just-s">
  <h2 class="fnt-20  myAccount-titles" *ngIf="!DBservice.ismobile">Categories</h2>
  <!-- <ion-title class="margin p0" *ngIf="!DBservice.ismobile">Categories</ion-title> -->
  <ion-button *ngIf="false && !DBservice.ismobile" fill="clear"  slot="end" class="headerButton" (click)="open_category('')">
    <ion-icon src="/assets/icons/add.svg"></ion-icon>
    New
  </ion-button>
</div>
<!--  <ion-segment scrollable (ionChange)="onCategoryChange($event)">
<ion-segment-button *ngFor="let c of categorylist; let index = index;" value="{{c.category_name}}">
  <ion-label>{{c.category_name}}</ion-label>
</ion-segment-button>
</ion-segment> -->
<ion-fab *ngIf="DBservice.ismobile" vertical="bottom" horizontal="end" slot="fixed">
  <!-- <ion-fab-button (click)="open(content,'Add')"> -->
  <ion-fab-button (click)="open_category('')">
    <ion-icon name="add"></ion-icon>
  </ion-fab-button>
</ion-fab>
<!-- {{categorylist | json}} -->
<ion-list *ngIf="DBservice.ismobile && categorylist.length != 0">
  <ion-item *ngFor="let c of categorylist; let index = index;" (click)="edit_category(c ,index)" lines="none" [ngClass]="{'activated': (active == index),'deactivated': (active != index)}" class="pl0">
    <ion-avatar slot="start">
      <div class="g41">
        <p>
          {{c.category_name[0]}}
        </p>
      </div>
    </ion-avatar>
    <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
    <ion-label class="m0">
      <h6 class="headertexth6">{{c.category_name}}</h6>
      <p class="pfont" *ngIf="c.products && c.products.length > 1">{{c.products?.length}} Items</p>
      <p class="pfont" *ngIf="c.products && c.products.length == 1">{{c.products?.length}} Item</p>
      <p class="pfont" *ngIf="!c.products">No Item</p>
    </ion-label>
  </ion-item>
</ion-list>

<div class="Fields-7" *ngIf="!DBservice.ismobile">
  <div class="table__data d__flex table__header">
    <div class="txt-center" >
      <ion-checkbox class="check__box" (click)="check_box = !check_box"></ion-checkbox>
      <!-- <ion-icon class="fnt-14" name="square-outline"></ion-icon> -->
    </div>
    <div>Image</div>
    <div>Category Name</div>
    <div>Category Id</div>
    <div class="">Display Order</div>
    <div class="">Is Active</div>
    <div class="">items</div>
  </div>
  <div class="orderss_list" #scrollMe (scroll)="onScroll($event)" *ngIf="categorylist.length != 0">
    <div class="main-item mouse" *ngFor="let item of categorylist; let index = index;" lines="none" [ngClass]="{'activated': (active == index),'deactivated': (active != index)}">
      <div class="table__data d__flex align-c table__items">
        <div class="txt-center">
          <ion-checkbox [checked]="check_box" class="check__box box__icon"></ion-checkbox>
          <!-- <ion-icon class="box__icon" name="square-outline"></ion-icon> -->
        </div>
        <div class="Product__Img" (click)="edit_category(item ,index)">
          <!-- <img *ngIf="item.menu_image" src="{{DBservice.open_image(item.menu_image)}}"> -->
          <img [src]="DBservice.product_img(item.menu_image)">
        </div>
        <div (click)="edit_category(item ,index)">
          <h6>{{item.category_name}}</h6>
        </div>
        <div (click)="edit_category(item ,index)">{{item.name}}</div>
        <div>{{item.display_order}}</div>
        <div (click)="edit_category(item ,index)">
          <ion-checkbox class="check__box" [checked]="item.is_active"></ion-checkbox>
        </div>
        <div (click)="edit_category(item ,index)">
          <p class="pfont m0" *ngIf="cat_count(item.name) > 1">{{cat_count(item.name)}} Items</p>
          <p class="pfont m0" *ngIf="cat_count(item.name) == 1">{{cat_count(item.name)}} Item</p>
          <p class="pfont m0" *ngIf="!cat_count(item.name)">No Item</p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="categorylist.length == 0">
    <ion-item *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]">
      <!-- <ion-thumbnail slot="start">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-thumbnail> -->
      <ion-label>
        <h3 class="d__flex just-s">
          <ion-skeleton-text animated style="width: 20px; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 10%; height: 16px"></ion-skeleton-text>
        </h3>
      </ion-label>
    </ion-item>
  </div>
</div>
<!-- Mobile view-->
<!--   <div class="Fields-2" *ngIf="DBservice.ismobile && categorylist.length != 0">
  <div class="table__data d__flex table__header">
    <div>Category Name</div>
    <div>items</div>
  </div>
  <div class="orderss_list">
    <div class="main-item mouse" *ngFor="let item of categorylist; let index = index;" (click)="edit_category(item ,index)" lines="none" [ngClass]="{'activated': (active == index),'deactivated': (active != index)}">
      <div class="table__data d__flex table__items">
        <div>
          <h6>{{item.category_name}}</h6>
        </div>
        <div>
          <p class="pfont" *ngIf="item.products && item.products.length > 1">{{item.products?.length}} Items</p>
          <p class="pfont" *ngIf="item.products && item.products.length == 1">{{item.products?.length}} Item</p>
          <p class="pfont" *ngIf="!item.products">No Item</p>
        </div>
      </div>
    </div>
  </div>
</div> -->